define('models/product_category',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'product-categories/' + this.id + '/' ) :
                ( App.Config.apiBase + 'product-categories/' );
        },

        defaults: function () {
            return {
                id: null,
                code: '',
                store_order: 0,
                translations: {
                    en: {
                        name: null,
                        info: null
                    },
                    tr: {
                        name: null,
                        info: null
                    }
                }
            };
        }
    });
});
